

// // Perimetraje

// const locationsLatitudes = {
//   locations: [
//     {
//       name: "82-85 Avenida Carrera 19",
//       lat: 4.6695813,
//       lon:  -74.0583593    
//     },
//     {
//       name: "Aeropuerto El Dorado",
//       lat: 4.6521983, 
//       lon: -74.1055248      
//     },
//     {
//       name: "Alamedas",
//       lat: 8.7631172, 
//       lon: -75.8734232  
//     },
//     {
//       name: "Buenavista Crocs",
//       lat: 11.2537143, 
//       lon: -74.2051482   
//     },
//     {
//       name: "Caracoli",
//       lat: 7.0715748, 
//       lon:-73.1051909    
//     },
//     {
//       name: "Chipichape Crocs",
//       lat: 7.122734, 
//       lon:  -73.1106327  
//     },
//     {
//       name: "El Tesoro Medellín",
//       lat: 6.1974387, 
//       lon: -75.5581384 
//     },
//     {
//       name: "Fontanar",
//       lat: 4.9176499, 
//       lon: -74.0309274
//     },
//     {
//       name: "Gran Estación Crocs",
//       lat: 4.6480015, 
//       lon: -74.1011198
//     },
//     {
//       name: "Jardin Plaza Cali",
//       lat: 3.3691967, 
//       lon: -76.5275155    
//     },
//     {
//       name: "Jardín Plaza Cúcuta",
//       lat: 7.9247141, 
//       lon: -72.4828964    
//     },
//     {
//       name: "Kronotime S.A.S",
//       lat: 4.6695813, 
//       lon: -74.0583593    
//     },
//     {
//       name: "La Serrezuela",
//       lat: 10.4228041, 
//       lon:  -75.5431477  
//     },
//     {
//       name: "Mall Plaza Barranquilla K.Crocs",
//       lat: 11.0119189, 
//       lon: -74.8237848   
//     },
//     {
//       name: "Mall Plaza Cali Crocs",
//       lat: 3.4135035, 
//       lon: -76.5472252   
//     },
//     {
//       name: "Mall Plaza Cartagena Crocs",
//       lat: 10.4090124, 
//       lon: -75.5156706     
//     },
//     {
//       name: "Mayorca Sabaneta",
//       lat: 6.1618172, 
//       lon: -75.6055153
//     },
//     {
//       name: "Parque Arboleda Pereira",
//       lat: 4.8067926, 
//       lon: -75.6837536   
//     },
//     {
//       name: "Plaza Central Crocs",
//       lat: 4.6317959, 
//       lon: -74.1163047   
//     },
//     {
//       name: "Titan Plaza",
//       lat: 4.6456032, 
//       lon: -74.1301377   
//     },
//     {
//       name: "Único Outlet Bucaramanga Crocs",
//       lat: 7.0852777, 
//       lon: -73.1223807   
//     },
//     {
//       name: "Zona T Crocs",
//       lat: 4.6669722, 
//       lon: -74.0539101   
//     }
//   ]
// };

//   // Definir la clave de la API de forma global
//   const googleMapsApiKey = "AIzaSyCPUbBhv9j817ME4rKfPwZcqjT7Wxyj--g";

// let map;
// function initMap() {
//   // Coordenadas centrales para el mapa (en este caso, las de la primera ubicación)
//   const center = { lat: 4.6695813, lng: -74.0583593 };

//   // Crear el mapa
//   map = new google.maps.Map(document.getElementById('map'), {
//     zoom: 6,
//     center: center
//   });

//   // Crear un marcador para cada ubicación
//   locationsLatitudes.locations.forEach(location => {
//     const marker = new google.maps.Marker({
//       position: { lat: location.lat, lng: location.lon },
//       map: map,
//       title: location.name
//     });

//     // Agregar un evento de clic en cada marcador para mostrar el nombre de la ubicación
//     marker.addListener('click', () => {
//       alert('Ubicación: ' + location.name);
//     });
//   });
// }

//     // Cargar la API de Google Maps de forma dinámica
//     const script = document.createElement('script');
//     script.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&callback=initMap`;
//     script.async = true;
//     script.defer = true;
//     document.head.appendChild(script);


// Sucursales con Stock: 

// const locations = ["Bogotá", "Bucaramanga", "Cali", "Cartagena", "Chia", "Cúcuta", "Medellín", "Montería", "Pereira", "Sabaneta", "Santa Marta"];
// let ciudadSeleccionada = "";
// ciudadSeleccionada = localStorage.getItem('ciudadSeleccionada') ? localStorage.getItem('ciudadSeleccionada') : "";
// localStorage.setItem('disponibilidadEnvio', ''); 

// let variantId = "";
// $(document).on("click", ".item-talla", function(){
//   console.log('Click');  

//   document.querySelectorAll('.pickup-store__option').forEach(option => {
//     if (!option.classList.contains('pickup-store__option--disabled')) {
//       option.classList.add('pickup-store__option--disabled');
//     }
//   });

//   if($(this).data('variant')){

//     console.log($(this));
    

//     variantId = $(this).data('variant');
//     console.log($(this).data('variant'));

//     console.log($("#shopify-section-store-availability").length);

//     if ($("#storeDispnible").length > 0) {
//       document.getElementById('storeDispnible').innerHTML = "";
//       $("#storeDispnible").empty();
//       // document.getElementById('storeDispnible').innerHTML = `¡No existe disponibilidad de retiro en tienda!`;
//   }

//     storeAvailability(variantId);
//     if ($("#store-availability-container--disabled").length) {
//       $("#store-availability-container--disabled").hide();
//     }
//   }
  
// }); 

// if(document.querySelector('#storeDispnible').dataset.variantId){
//   storeAvailability(document.querySelector('#storeDispnible').dataset.variantId);
//   if ($("#store-availability-container--disabled").length) {
//     $("#store-availability-container--disabled").hide();
//   }
// }

// function storeAvailability(variantId){  

//   $("#shopify-section-store-availability").remove();


//   let reqURL = window.Shopify.routes.root + "variants/"+variantId+"/?section_id=store-availability";

//   fetch(reqURL)
//   .then(response => response.text())
//   .then(text => {
//       let ciudades = [];
//       let tiendas = [];
//       const container = document.querySelector('[data-store-availability-container]');
//       const pickupAvailabilityHTML = new DOMParser()
//         .parseFromString(text, 'text/html')
//         .querySelector('.shopify-section');

//           container.appendChild(pickupAvailabilityHTML);

//           const storeAddress = document.querySelectorAll('.store-availability-list__address');

//           if(storeAddress){  
            
//             storeAddress.forEach( store => {

//               ciudades.push(`${store.dataset.address}`);       

//                 tiendas.push({
//                   tienda: `${store.dataset.storeName}`,
//                   content: `${store.innerHTML}`,
//                   city: `${store.dataset.address}`,
//                   stock: `${store?.parentElement?.querySelector('.store-availability-list__stock')?.outerHTML}`
//                 });
  
//                 console.log('Tiendas: ', tiendas);
//             });


//             let disponibilidadEnvio = 'false';

//             // Dirección a verificar
//             const direccionVerificar = "82-85 Avenida Carrera 19";

//             // Buscar y actualizar disponibilidad
//             const index = tiendas.findIndex(store => store.tienda === direccionVerificar);
//             if (index !== -1) {
//               disponibilidadEnvio = 'true';
//               tiendas.splice(index, 1);
//             }

//             // Almacenar en localStorage
//             localStorage.setItem("disponibilidadEnvio", disponibilidadEnvio);

//             // Resultados
//             console.log("Disponibilidad de envío:", disponibilidadEnvio);
//             console.log("Tiendas restantes:", tiendas);

            
//           }

//           if(ciudades.length > 0 ){
//              ciudades = Object.keys(ciudades.reduce((acc, item) => {
//               acc[item] = true;
//               return acc;
//             }, {}));
//           }

//           updateProductCiudades(ciudades, tiendas);

//   })
//   .catch(e => {
//       console.error(e);
//   });  
// }



function activateIndicators(){

}


// function updateProductCiudades(ciudades, tiendas){
//       console.log('Ciudades: ', ciudades);
//       console.log('Tiendas: ', tiendas);
      
//       localStorage.setItem('ciudadesTiendas', ciudades);
      
//       const options = document.querySelectorAll('.pickup-store__option');

//       if(!tiendas.length > 0 && !ciudades.length > 0){
//       // const selector = document.getElementById('storeDispnible');
     
//       //   if(selector){
//       //     selector.innerHTML = `<span>¡No existe disponibilidad de retiro en tienda!</span>`;
//       //   }

      

//         // if(options){
//         //   options.forEach(option => {
//         //     if(option.classList.contains('pickup-store__option--enabled')){
//         //       option.classList.remove('pickup-store__option--enabled');
//         //       option.classList.add('pickup-store__option--disabled');
//         //     }
//         //   });
//         // }
//       } else {
//         // if(options){
//         //   options.forEach((option, i) => {
//         //     if(option.classList.contains('pickup-store__option--disabled')){
//         //       option.classList.remove('pickup-store__option--disabled');
//         //       option.classList.add('pickup-store__option--enabled');
//         //     }
//         //   });
//         // }

//           // Shipping
//           if(localStorage.getItem('disponibilidadEnvio') === 'true'){
//             console.log('Disponinibilidad de envio 2');
            
//              if(options){
  
//               console.log('Options: ', options); 
              
  
//               options.forEach(option => {
//                 console.log(option);
                
//                 console.log(option.dataset.storeType);
                
//                 if(option.dataset.storeType === 'ship'){
//                   if(option.classList.contains('pickup-store__option--disabled')){
//                     option.classList.remove('pickup-store__option--disabled');
//                   }
//                 }            
//               });
//             }
//           }

//           // Pickup
//           if(options && tiendas.length > 0){
  
//             console.log('Options: ', options); 
            

//             options.forEach(option => {
//               console.log(option);
              
//               console.log(option.dataset.storeType);
              
//               if(option.dataset.storeType === 'pick'){
//                 if(option.classList.contains('pickup-store__option--disabled')){
//                   option.classList.remove('pickup-store__option--disabled');
//                 }
//               }            
//             });
//           }
//       }

//       for(let i = 0; i < ciudades.length; i++){
//         let ciudad = ciudades[i].normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ñ/g, "n").replace(/Ñ/g, "N").replace(/\s+/g, "-");

//         console.log('Ciudad ', ciudad);
        

//         /**/


        
//         if(locations.length > 0 && ciudades.length > 0 && ciudadSeleccionada){
//           const filteredLocations = ciudades.filter(city => city === ciudadSeleccionada);



//             // Si hay coincidencias, usa el arreglo filtrado; si no, usa el arreglo original
//           // ciudades = filteredLocations.length > 0 ? filteredLocations : ciudades;
//           ciudades = filteredLocations.length > 0 ? filteredLocations : [];

//           console.log('Coincide: ', ciudades); // Resultado: ["Bogotá"] si coincide, o el arreglo original

//         }else {
//           ciudades = localStorage.getItem('ciudadesTiendas').split(",");
//         }

//         /**/
//         if(ciudades.length > 0 && tiendas.length > 0){
//           $(".container-ciudades").append("<div class='item-list-tiendas'><span>"+ciudades[i]+"</span><div class='container-tiendas-product container-tiendas-product-"+ciudad+"'></div></div>");


//           for(let j = 0; j < tiendas.length; j++){

//             console.log(tiendas[j].tienda == ciudades[i]);

//             console.log('Tiendas en J: ', tiendas[j]);
            

//             if(tiendas[j].city == ciudades[i]){
//               console.log($(`.container-tiendas-product-${ciudad}`));
  
//               document.querySelector(`.container-tiendas-product-${ciudad}`).insertAdjacentHTML('afterbegin', `
//                 <div>${tiendas[j].stock}</div>
//                 <span>${tiendas[j].tienda}</span>
//                 <div>${tiendas[j].content}</div>
//                 `);
//             }
//           }
//         }else {
//           document.getElementById('storeDispnible').innerHTML = `¡No existe disponibilidad de retiro en tienda!`;
//         }
      
//       }
//       $(".container-ciudades .item-list-tiendas").click(function(){
//         if($(this).find('.container-tiendas-product').is(":visible")){
//             $('.container-tiendas-product').attr("style", "display: none;");
//         	$(this).find('.container-tiendas-product').attr("style", "display: none;")
//         }else{
//             $('.container-tiendas-product').attr("style", "display: none;");
//           	$(this).find('.container-tiendas-product').attr("style", "display: block; animation: zoomAnimation2 2s")
//         }
        
//       })
// }

// $(document).on("click", ".store-availability-information", function(){

//   console.log('Click en...');
  

//   // Cuando es solo una variante: 
//   if($('#store-availability-container--disabled').data('variantId')) {
//     let variantId = $('#store-availability-container--disabled').data('variantId');
//     storeAvailability(variantId);
//   }

//   if($("#StoreAvailabilityModal").is(":visible")){
//     $("#StoreAvailabilityModal").attr("style", "display: none");  
//   }else{
//     $("#StoreAvailabilityModal").attr("style", "display: flex");
//     $("#imageProduct").attr('src', $("#storeDispnible").attr("data-product-image"));
//   }
// })

// $(document).on("click", "#closeModalStoreAvailability", function(){
//    $("#StoreAvailabilityModal").attr("style", "display: none");  
// });

// $("#StoreAvailabilityModal").click(function() {
//    $(this).attr("style", "display: none");
// });

// $(document).on("click", ".content-store-availability", function(event){
//     event.stopPropagation();
// });

// $(document).on("click", '#closeModalStoreAvailability', function(event){
//     event.stopPropagation();
// });

// $(document).on("click", "#add-cart-store-avaible", function(){
//     addProductStoreAvailability($(this).attr("data-id-product-variant"));
// });


document.addEventListener("click", function(event) {
  const target = event.target.closest("#add-cart-store-avaible");
  if (target) {
    const productId = target.getAttribute("data-id-product-variant");
    addProductStoreAvailability(productId);
  }
});

function addProductStoreAvailability (idVariant){
    console.log(idVariant)
    let formData = {
      'items': [{
      	'id': parseInt(idVariant),
      	'quantity': 1
      }]
    };
    fetch('/cart/add.js', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json'
       },
       body: JSON.stringify(formData)
    })
    .then(response => {
       $(this).text("Agregado!").css("background","black");
       location.href = "/cart";
       
	})
    .catch((error) => {
       console.error('Error:', error);
    });
};


